import React, { useState, useRef, useEffect } from 'react';

const MultiSelect = ({ label, options, selectedValues, onChange, errorMsg, className, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (label) => {
    if (selectedValues?.includes(label)) {
      onChange(selectedValues.filter((selectedLabel) => selectedLabel !== label));
    } else {
      onChange([...selectedValues, label]);
    }
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`w-full ${className}`} ref={containerRef} {...props}>
      <label className="block text-gray-700 font-bold mb-2 dark:text-slate-200">
        {label}
      </label>
      <div className="relative">
        <div
          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 cursor-pointer flex items-center"
          onClick={handleToggle}
        >
          <span className="flex-1">
            {selectedValues?.length > 0
              ? selectedValues.join(', ')
              : `Select ${label?.toLowerCase()}`}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-4 w-4 transition-transform duration-200 ${
              isOpen ? 'transform rotate-180' : ''
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
        {isOpen && (
          <div className="absolute z-10 mt-1 w-full bg-white dark:bg-slate-900 border border-gray-100 dark:border-gray-800 rounded shadow-lg">
            {options?.map((option) => (
              <label
                key={option.value}
                className="block px-4 py-2 text-gray-700 dark:text-slate-200 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
              >
                <input
                  type="checkbox"
                  value={option.label}
                  checked={selectedValues?.includes(option.label)}
                  onChange={() => handleSelect(option.label)}
                  className="mr-2"
                />
                {option.label}
              </label>
            ))}
          </div>
        )}
      </div>
      {
        errorMsg && <div className='text-red-500 my-2' >{errorMsg}</div>
      }
    </div>
  );
};

export default MultiSelect;
